<template>
  <div class="LKReportsRoadmapCommon">
    <LKReportsRoadmapCommonTitle
      :data="data"
      :skeleton="skeleton"
    />

    <template v-for="(school) in schools">
      <template v-for="(roadmap) in school.roadmaps">
        <BLayoutExpansion
          :key="`${school.id}-${roadmap.id}`"
          extendless
          style="margin-bottom: 16px;"
        >
          <template #header>
            <div class="LKReportsRoadmapCommon__row">
              <div>
                <b>{{ school.code }}</b>
                <span style="padding: 4px;" />
                <span>{{ roadmap.name }}</span>
              </div>

              <div class="LKReportsRoadmapCommon__link-container">
                <router-link :to="getRoute(roadmap.id, school.id)">
                  <IconLink @click.stop />
                </router-link>
              </div>
            </div>
          </template>

          <LKReportsRoadmapCommonTable
            :list="roadmap.rows"
            :skeleton="skeleton"
          />
        </BLayoutExpansion>
      </template>
    </template>
  </div>
</template>

<script>
import memoize from 'lodash/memoize'
import { LK_ROADMAPS_FEED_ROUTES } from '@/views/LKRoadmapsFeed/utils'

import IconLink from '@/components/lk/icons/LKIconLink.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import LKReportsRoadmapCommonTitle from './LKReportsRoadmapCommon/LKReportsRoadmapCommonTitle.vue'
import LKReportsRoadmapCommonTable from './LKReportsRoadmapCommon/LKReportsRoadmapCommonTable.vue'


const BATCH_COUNT = 20
const BATCH_TIMEOUT = 200
const getRouteResolver = (roadmapId, schoolId) => `${roadmapId}--${schoolId}`

export default {
  name: 'LKReportsRoadmapCommon',
  components: {
    IconLink,
    BLayoutExpansion,
    LKReportsRoadmapCommonTitle,
    LKReportsRoadmapCommonTable,
  },
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    batchCount: 0,
  }),
  computed: {
    schools() {
      return this.data.schools?.slice(0, this.batchCount)
    },
  },
  created() {
    this.getRoute = memoize(
      this.getRoute,
      getRouteResolver,
    )
  },
  mounted() {
    this.$nextTick(this.updateBatch)
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    getRoute(roadmapId, schoolId) {
      const route = {
        name: LK_ROADMAPS_FEED_ROUTES.VIEW,
        params: {
          id: roadmapId,
          school_id: schoolId,
        },
      }

      return route
    },
    updateBatch() {
      this.timerId = setTimeout(() => {
        this.batchCount += BATCH_COUNT
        if (this.batchCount < this.data.schools?.length) {
          this.$nextTick(this.updateBatch)
        }
      }, BATCH_TIMEOUT)
    },
  },
}
</script>

<style lang="scss">
.LKReportsRoadmapCommon {
  &__row {
    display: flex;
    width: 100%;
  }

  &__link-container {
    margin: -10px 10px -10px auto;
  }
}
</style>
